import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';


@Component({
  selector: 'app-company-sample-report-page',
  templateUrl: './company-sample-report-page.component.html',
  styleUrls: ['./company-sample-report-page.component.scss']
})
export class CompanySampleReportPageComponent {

  company_url: any;
  product_name:any;
  sku:any;
  deviceType;

  constructor(private route: ActivatedRoute, private router: Router, private _location: Location) {
    this.route.params.subscribe((params) => {
      let company_name = params.name;
      this.product_name = params.report;
      this.sku = params.sku.toUpperCase();
      this.company_url = company_name.toLowerCase();
      this.company_url = this.company_url.replaceAll(' ', '-');
    });

    this.deviceType = localStorage.getItem('deviceType');
   
  }

  goBack(event: MouseEvent) {
    event.preventDefault();  // Prevent the default anchor behavior
    this._location.back();
  }
}
